import * as tslib_1 from "tslib";
import * as MailRowDataPropertyGetter from '../selectors/mailRowDataPropertyGetter';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import strings from 'owa-strings/owa-mail-strings';
export default function getMailListRowDragData() {
    // Also rename this to getMailListRowDragData. May be get this information from the mailRowData getter api
    var tableView = getSelectedTableView();
    var latestItemIds = [];
    var subjects = [];
    var selectedRowKeys = tslib_1.__spread(tableView.selectedRowKeys.keys());
    var listViewType = tableView.tableQuery.listViewType;
    var itemType = selectedRowKeys.length > 1
        ? listViewType == 0 /* Conversation */
            ? DraggableItemTypes.MultiMailListConversationRows
            : DraggableItemTypes.MultiMailListMessageRows
        : DraggableItemTypes.MailListRow;
    selectedRowKeys.forEach(function (rowKey) {
        var subject = MailRowDataPropertyGetter.getSubject(rowKey, tableView);
        subjects.push(subject ? subject : strings.noSubject);
        var itemIds = MailRowDataPropertyGetter.getItemIds(rowKey, tableView);
        latestItemIds.push(itemIds[0]);
    });
    return {
        itemType: itemType,
        tableViewId: tableView.id,
        tableListViewType: listViewType,
        rowKeys: selectedRowKeys,
        subjects: subjects,
        latestItemIds: latestItemIds,
    };
}
//# sourceMappingURL=getMailListRowDragData.js.map